import VenueHighlights, { VenueHighlight } from './VenueHighlights';

export { VenueHighlight };
export default VenueHighlights;
